export function getApiHost() {
  return '/__api__';
}
